import { buttonCls } from '@qr-front/ui/components/Button'
import { cn } from '@qr-front/ui/utils'
import { ReactElement } from 'react'

export const InputButton = ({
	icon,
	onClick,
	className,
	ariaLabel,
	size = 'icon-large',
}: {
	icon: ReactElement
	onClick: () => void
	className?: string
	ariaLabel?: string
	size?: 'default' | 'large' | 'icon' | 'icon-large'
}) => (
	<div
		role="button"
		aria-label={ariaLabel}
		onClick={onClick}
		onKeyUp={(event) => {
			if (event.key === 'Enter') {
				onClick()
			}
		}}
		tabIndex={0}
		className={cn(
			buttonCls({ visual: 'soft', size }),
			'shrink-0 bg-transparent',
			className,
		)}
	>
		{icon}
	</div>
)
